import parseDomain from 'parse-domain';

/**
 * Domain sanitization result object containing all information about the current domain sanitization done.
 */
class DomainSanitizationResult {
    /**
     * Constructor
     *
     * @param {string} sanitizedInput
     * @param {string} input
     */
    constructor(sanitizedInput, input) {
        this.sanitizedInput = sanitizedInput;
        this.input = input;
    }

    /**
     * Creates a domain sanitization result instance from an input string.
     *
     * @param {string} input
     *
     * @return {DomainSanitizationResult}
     */
    static createFromInput(input) {
        let sanitizedInput = String(input)
            .toLowerCase()
            .replace(/\s/g, '')
            .replace(/\.*$/, '');
        const parsedDomain = parseDomain(sanitizedInput);

        if (parsedDomain) {
            let domainParts = [];

            if (parsedDomain.domain) {
                domainParts.push(parsedDomain.domain);
            }
            if (parsedDomain.tld) {
                domainParts.push(parsedDomain.tld);
            }

            sanitizedInput = domainParts.join('.');

            return new DomainSanitizationResult(sanitizedInput, input);
        }

        // remove all non-ASCII characters from string
        sanitizedInput = sanitizedInput.replace(/[^a-z0-9-]/g, '');

        return new DomainSanitizationResult(sanitizedInput, input);
    }
}

/**
 * Creates a domain sanitization result from an input string.
 */
class DomainSanitizationFactory {
    /**
     * Creates a domain sanitization result from an input string.
     *
     * @param  {string} input
     *
     * @return {DomainSanitizationResult}
     */
    sanitize(input) {
        return DomainSanitizationResult.createFromInput(input);
    }
}

export { DomainSanitizationFactory };
